var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


window.$modalDescription = window.$modalDescription || '';
window.$modalFields = window.$modalFields || '';

var RingBuilder = new Vue({
  el: '#summary_bar',
  data: {
    pairRings: [],
    show_options: false,
    show_props: true,
    regularClass: 'column is-2-desktop is-4-tablet',
    singleRingClass:  'is-offset-5',
    customised: false,
    pairCustomiseTotal: 0,
    pairTotal: 0,
    formattedPrice: 0,
    formattedCustomisations: 0
  },
  created: function() {
    this.getCart()
  },
  beforeUpdate: function() {
    this.formatPrice()
  },
  methods: {
    filterProps: function(properties) {
      const obj = {}
      Object.keys(properties).forEach(key => {
        if(key !== '_is_pair') {
          obj[key] = properties[key]
        }
      })
      return obj;
    },
    getCart: function() {
      var inst = this;
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then(data => {
        inst.checkCart(data);
      })
      .catch(errorThrown => {
        console.log(errorThrown);
      })
    },
    checkCart: function(cart) {
      for(i in cart.items) {
        let item = cart.items[i];
        if("_is_pair" in item.properties) {
          this.pairRings.push(item);
          this.pairTotal += item.price;
          this.show_options = true;
        }
        if("is_customised" in item.properties) {
          this.customised = true;
          if("customise_price" in item.properties) {
            this.pairCustomiseTotal += parseInt(item.properties["customise_price"])
          }
        }
      }
      this.formatPrice();
    },
    formatPrice: function() {
      this.formattedPrice = Shopify.formatMoney(this.pairTotal, Shopify.money_format);
      if (this.pairCustomiseTotal > 0) {
        this.formattedCustomisations = Shopify.formatMoney(this.pairCustomiseTotal, Shopify.money_format);
      } else {
        this.formattedCustomisations = 0
      }
    },
    launchEditModal: function(index, target, evt) {
      // TODO Replace with tingle modal

      evt.preventDefault();

      const modalContent = document.getElementById(`${target}--content`);
      this.productJson = JSON.parse(document.getElementById(`${target}--json`).innerText);
      const form = modalContent.querySelector('[action="/cart/add"]');
      const ring = this.pairRings[index]

      this.editModal = new tingle.modal({
        footer: false, 
        stickyFooter: false,
        closeMethods: ['escape', 'overlay'],
        cssClass: [],
        onOpen: () => {
          console.log('Edit modal opened');
          modalContent.classList.remove('hidden');
          this.populateForm(ring, index, form);
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            const key = e.currentTarget.querySelector('[type="submit"]').dataset.removeKey;
            const index = e.currentTarget.querySelector('[type="submit"]').dataset.removeIndex;
            this.removeAndAdd(key, index, e.currentTarget);
          });
          const modalOptions = modalContent.querySelectorAll('.Modal__Options');
          modalOptions.forEach((elem, i) => {
            elem.addEventListener('change', (e) => {
              console.log('option changed');
              this.setVariant(this.productJson, form, modalContent);
            });
          })
        },
        onClose: () => {
          console.log('Edit modal closed');
          const content = this.editModal.getContent().firstElementChild;
          content.classList.add('hidden');
          document.body.appendChild(content);
          this.editModal.destroy();
        },
        beforeClose: () => {
          return true;
        }
      });

      this.editModal.setContent(modalContent)

      this.editModal.open();
    },
    populateForm: function(ring, index, form) {
      ring.variant_options.forEach(function(option, index) {
        let className = `.option-${index+1}`;
        const options = form.querySelectorAll(className);
        options.forEach((obj, i) => {
          obj.querySelector(`[value="${option}"]`).setAttribute('selected', true);
        });
      });
      if(ring.properties.hasOwnProperty('Engraving Service')) {
        form.querySelector('input[name="properties[Engraving Service]"]').val(ring.properties['Engraving Service']);
        form.querySelector('button[type="submit"]').attr('data-remove-custom-price', ring.properties['customise_price']);
      }
      if (ring.properties.hasOwnProperty('Select Font')) {
        form.querySelector(`select option[value="${ring.properties['Select Font']}"]`).attr('selected', true);
      }
      form.querySelector('button[type="submit"]').setAttribute('data-remove-key', ring.key);
      form.querySelector('button[type="submit"]').setAttribute('data-remove-index', index);
    },
    removeAndAdd: function(key, index, form) {
      const self = this;
      const ring = self.pairRings[index];
      const body = {
        id: key,
        quantity: 0
      };
      fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(res => {
        res.json()
      }).then(data => {
        console.log(data);
        if(ring.properties.hasOwnProperty('customise_price')) {
          self.pairCustomiseTotal -= ring.properties['customise_price'];
        }
        self.pairTotal -= ring.price;
        self.pairRings.splice(index, 1);
        if(self.pairRings.length < 2) {
          self.addRing(form);
        }
      }).catch(error => {
        console.log(error);
      })
    },
    addRing: function(form) {
      const self = this;
      const formData = new FormData(form);
      const body = {
        items: [
          {
            id: parseInt(formData.getAll('id')[0], 10),
            quantity: parseInt(formData.getAll('quantity')[0], 10),
            properties: self.getFormProperties(form)
          }
        ]
      }
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        RingBuilder.$data.pairRings.push(data.items[0]);
        RingBuilder.$data.pairTotal += data.items[0].price;
        this.editModal.close();
      })
      .catch(errorThrown => {
        console.log(errorThrown);
      });
    },
    removeRing: function(key, index) {
      const self = this;
      const ring = self.pairRings[index];
      const body = {
        id: key,
        quantity: 0
      };
      fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(res => {
        res.json()
      }).then(data => {
        console.log(data);
        if(ring.properties.hasOwnProperty('customise_price')) {
          self.pairCustomiseTotal -= ring.properties['customise_price'];
        }
        self.pairTotal -= ring.price;
        self.pairRings.splice(index, 1);
      }).catch(error => {
        console.log(error);
      })
    },
    setVariant: function(product, form, modalContent) {
      const self = this;
      let variant = [],
      id;
      for(var i = 1; i < 4; i++) {
        var options = form.querySelectorAll(`.option-${i}`);
        if(options.length) {
          options.forEach((option) => {
            variant.push(option.value);
          })
        }
      }
      if(variant.length > 1) {
        variant = variant.join(' / ');
      } else {
        variant = variant.join('');
      }
      for(const p in product.variants) {
        if(product.variants[p].title === variant) {
          id = product.variants[p].id;
          modalContent.querySelector('.money').innerText = Shopify.formatMoney(product.variants[p].price, Shopify.money_format);
        }
      }
      form.querySelector('[name="id"]').value = id;
    },
    getFormProperties: function(form) {
      const obj = {};
      const props = form.querySelectorAll('[name^="properties"]');
      props.forEach((prop) => {
        if(prop.value !== '') {
          const key = prop.getAttribute('name').replace('properties[', '').replace(']', '');
          obj[key] = prop.value;
        }
      })
      obj['_is_pair'] = "true";
      return obj;
    }
  }
});

class CouplesRingBuilder {
  constructor({ triggers, product }) {
    this.triggers = triggers,
    this.modalContent = null;
    this.modalForm = null;
    this.modalOptions = null;
    this.productJson = {};

    this.launchPairModal = this.launchPairModal.bind(this);
    this.setVariant = this.setVariant.bind(this);
    this.getFormProperties = this.getFormProperties.bind(this);
    this.submitform = this.submitForm.bind(this);
  }

  init() {
    console.log('reinitialised');
    const self = this;
    const triggerElems = document.querySelectorAll(self.triggers);
    triggerElems.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        if(!target.classList.contains('product-out')) {
          this.launchPairModal(target);
        }
      });
    });
  }

  launchPairModal(elem) {
    const self = this;
    self.modalContent = document.getElementById(`${elem.dataset.target}--content`);
    self.pairModal = new tingle.modal({
      footer: false, 
      stickyFooter: false,
      closeMethods: ['escape', 'overlay'],
      cssClass: [],
      onOpen: () => {
        console.log('Pair ring modal opened');
        self.modalContent.classList.remove('hidden');
        self.modalForm = self.modalContent.querySelector('[action="/cart/add"]');
        self.productJson = JSON.parse(document.getElementById(`${elem.dataset.target}--json`).innerText);
        debugger
        if(typeof window[`customiserModal_${self.productJson.id}`] === "object") {
          window[`customiserModal_${self.productJson.id}`].init();
        }
        self.modalForm.addEventListener('submit', (e) => {
          e.preventDefault();
          if(RingBuilder.$data.pairRings.length < 2 && self.productJson.available) {
            this.submitForm(self.modalForm);
          }
        });
        self.modalOptions = self.modalContent.querySelectorAll('.Modal__Options');
        self.modalOptions.forEach((elem, i) => {
          elem.addEventListener('change', (e) => {
            this.setVariant(self.productJson, self.modalForm);
          });
        })
      },
      onClose: () => {
        console.log('Pair ring modal closed');
        const content = this.pairModal.getContent().firstElementChild;
        content.classList.add('hidden');
        document.body.appendChild(content);
        this.pairModal.destroy();
      },
      beforeClose: () => {
        return true;
      }
    });

    self.pairModal.setContent(self.modalContent);

    self.pairModal.open();
  }

  setVariant(product, form) {
    const self = this;
    let variant = [],
    id;
    for(var i = 1; i < 4; i++) {
      var options = form.querySelectorAll(`.option-${i}`);
      if(options.length) {
        options.forEach((option) => {
          variant.push(option.value);
        })
      }
    }
    if(variant.length > 1) {
      variant = variant.join(' / ');
    } else {
      variant = variant.join('');
    }
    for(const p in product.variants) {
      if(product.variants[p].title === variant) {
        id = product.variants[p].id;
        self.modalContent.querySelector('.money').innerText = Shopify.formatMoney(product.variants[p].price, Shopify.money_format);
      }
    }
    form.querySelector('[name="id"]').value = id;
  }

  getFormProperties(form) {
    const obj = {};
    const props = form.querySelectorAll('[name^="properties"]');
    props.forEach((prop) => {
      if(prop.value !== '') {
        const key = prop.getAttribute('name').replace('properties[', '').replace(']', '');
        obj[key] = prop.value;
      }
    })
    obj['_is_pair'] = "true";
    return obj;
  }

  submitForm(form) {
    const self = this;
    const formToSubmit = new FormData(form);
    const body = {
      items: [{
        'id': parseInt(formToSubmit.getAll('id')[0], 10),
        'quantity': parseInt(formToSubmit.getAll('quantity')[0], 10),
        'properties': self.getFormProperties(form)
      }]
    }
    debugger
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => res.json())
    .then(data => {
      console.log(data);
      RingBuilder.$data.pairRings.push(data.items[0]);
      RingBuilder.$data.pairTotal += data.items[0].price;
      this.pairModal.close();
    })
    .catch(errorThrown => {
      console.log(errorThrown);
    });
  }

}

document.addEventListener('DOMContentLoaded', (e) => {
  if(!window.ringBuilder) {
    const options = {
      triggers: '.launch--couples-modal'
    }
    window.ringBuilder = new CouplesRingBuilder(options);
    ringBuilder.init();
  }
});
